import { Injectable } from '@angular/core';
import { DocumentFile } from '../../../../ui-components/lib/upload-documents/upload-documents.interface';

@Injectable({ providedIn: 'root' })
export class FileService {
  files: FileData[] = [];
}

export interface FileData {
  key: string;
  files: DocumentFile[];
}
